import React from "react";
import {
  Home,
  Droplet,
  DollarSign,
  Bot,
  Settings,
  LogOut,
  ChevronLeft,
  ChevronRight,
  FileSpreadsheet,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const FarmerSidebar = ({ isOpen, onToggle }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const menuItems = [
    { name: "Dashboard", icon: <Home size={20} />, path: "/farmer-dashboard" },
    { name: "Milk Records", icon: <Droplet size={20} />, path: "/farmer/milk-records" },
    { name: "Payments", icon: <DollarSign size={20} />, path: "/farmer/payments" },
    { name: "Ask AI", icon: <Bot size={20} />, path: "/farmer/ai-assistant" },
    { name: "Earn Money", icon: <FileSpreadsheet size={20} />, path: "/annotation-marketplace" },
    { name: "Settings", icon: <Settings size={20} />, path: "/farmer/settings" },
  ];

  return (
    <div className="h-full flex flex-col justify-between">
      {/* Top section */}
      <div>
        <div className="flex items-center justify-between p-4 border-b">
          <motion.h1
            initial={{ opacity: 0 }}
            animate={{ opacity: isOpen ? 1 : 0 }}
            className="text-lg font-bold text-green-700"
          >
            Farmer
          </motion.h1>
          <button onClick={onToggle} className="text-green-600 hover:text-green-800">
            {isOpen ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
          </button>
        </div>

        {/* Menu */}
        <nav className="mt-4">
          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className="flex items-center gap-3 px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors"
            >
              {item.icon}
              {isOpen && <span>{item.name}</span>}
            </Link>
          ))}
        </nav>
      </div>

      {/* Logout button */}
      <div className="p-4 border-t">
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 text-red-600 hover:bg-red-50 px-4 py-2 rounded-md w-full"
        >
          <LogOut size={20} />
          {isOpen && <span>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default FarmerSidebar;
